/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const facilityInfrastructureEnumsPotentialConsequenceOptionEnum = {
    SLARisk: 'SLARisk',
    RedundancyLoss: 'RedundancyLoss',
    Outage: 'Outage',
    Other: 'Other',
} as const;

export type FacilityInfrastructureEnumsPotentialConsequenceOptionEnumKey =
    (typeof facilityInfrastructureEnumsPotentialConsequenceOptionEnum)[keyof typeof facilityInfrastructureEnumsPotentialConsequenceOptionEnum];

export type FacilityInfrastructureEnumsPotentialConsequenceOption =
    FacilityInfrastructureEnumsPotentialConsequenceOptionEnumKey;
